import React, {useEffect, useState} from 'react';
import {Button, Modal} from 'semantic-ui-react'

import './style.css';
import AccessChecker from "../AccessChecker";


import ExportIcon from "../../icons/export-icon.png";
import translations from "../../components/LanguageModal/translations";
import {useSelector} from "react-redux";
import {getLanguage} from "../../components/LanguageModal/reducer";
import {fetchTicketData} from "../AccessChecker/actions";
import {fetchUserData, subscribeToPushNotifications} from "../../components/UserLogin/actions";
import VCard from "../../components/VCard";
import {getTypeExhibition} from "../Home/reducer";

export default function Scan(props) {
    const {token, dispatch, mixpanel, navigate} = props;
    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const [open, setOpen] = useState(false);


    const t = (key) => {
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };
    useEffect(() => {
        window.scrollTo(0, 0);
        if (mixpanel) {
            mixpanel.track('View. Scan QR')
        }
        if (!token) {
            navigate('/', { state: {scanUnLogin: true}});
        }
    }, []);

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));
    const dataExhibition = {
        asia: {
            color: '#D81524'
        },
        gras: {
            color: '#037C00',
        }
    }

    const isIOS = () => {
        return /iPad|iPhone|iPod/.test(navigator.userAgent);
    };


    const requestNotificationPermission = () => {
        try {
            switch (Notification.permission) {
                case "default":
                    return {
                        text: '👌 ' + t('pushDefault'),
                        onClick: () => dispatch(subscribeToPushNotifications(token)),
                        style: {
                            cursor: 'pointer',
                            borderRadius: 8,
                            background: dataExhibition[typeExhibition].color,
                            fontWeight: 'bold',
                            color: 'white',
                            padding: '0 5px',
                            margin: '5px 0'
                        },
                    }
                case "granted":
                    return {
                        text: '❤️ ' + t('pushAllow'),
                        style: {cursor: 'default'}
                    }
                case "denied":
                    return {
                        text: '😢 ' + t('pushDenied'),
                        style: {cursor: 'pointer'},
                        onClick: () => navigate('/instruction')
                    }
            }
        }
        catch (error) {
            console.log(error);
        }
    };


    const handleSubmit = () => {
        const params = {
            ticket: scanResult,
            lang: languageString
        }

        dispatch(fetchTicketData(token, params)).
            then(() => dispatch(fetchUserData(token)))
    }
    const returnScanView = () => {
       return <>
           <div className="scan-text">
               {t("pointCamera")}
               {!isIOS() && <div className='push-text' style={requestNotificationPermission().style}
                     onClick={requestNotificationPermission().onClick}>{requestNotificationPermission().text}</div>
               }           </div>
           {/*<div className='scan-icon-container'>*/}
           {/*    <CornerIcon className="scan-photo-icon"/>*/}
           {/*    <PhotoIcon className="scan-photo-icon"/>*/}
           {/*</div>*/}
           <AccessChecker
               token={token}
           />

           {/*<Button className='scan-btn'>*/}
           {/*    <div className="scan-btn-text">{t("export")}</div>*/}
           {/*    <img src={ExportIcon} className="scan-export-icon"/>*/}
           {/*</Button>*/}
       </>
    }


    return (
        <div className="scan-view">
            {returnScanView()}
        </div>
    );
}
